export const createProject = {
  title: 'Projekterstellung',
  projectName: 'Projektname',
  projectNameQuestion: 'Geben sie ihrem Projekt einen Namen',
  realEstateQuestion: 'Für welche Immobilie möchten sie ihr Projekt erstellen?',
  createNewRealEstate: 'Neue Immobilie erstellen',
  selectNoRealEstate: 'Projekt mit keiner Immobilie verknüpfen',
  hausHeldRequestQuestion: 'Wollen sie Offerten von HausHeld.ch erhalten?',
  createProject: 'Projekt erstellen',
  subTitle1: 'Umbauprojekte',
  subTitle2: 'Handwerker und Dienstleistungen',
  cardTitleWindow: 'Fenster & Türen',
  cardTitleBath: 'Bad',
  cardTitleHeating: 'Heizung',
  cardTitleKitchen: 'Küchen',
  cardTitleSolar: 'Solaranlagen',
  cardTitleCarport: 'Carport',
  cardTitleWhirlpool: 'Whirlpool',
  cardTitleGarage: 'Garagen/Tore',
  cardTitleWintergarden: 'Wintergarten',
  cardTitleRoofer: 'Dachdecker',
  cardTitleFence: 'Zaun & Sichtschutz',
  cardTitleMetalConstruction: 'Metallbau',
  cardTitleBroker: 'Makler',
  cardTitleAwnings: 'Markisen',
  cardTitleRollerBlinds: 'Storen',
  cardTitlePainter: 'Maler/Gipser',
  cardTitleFloorer: 'Bodenleger',
  cardTitleIsolation: 'Isolation/Fassade',
  cardTitleWaterConditioning: 'Wasseraufbereitung',
  cardTitlePaver: 'Plattenleger',
  cardTitleAirConditioning: 'Klima',
  cardTitleCarpenter: 'Schreiner',
  cardTitleAssembling: 'Montage',
  cardTitleChippie: 'Zimmermann',
  cardTitleRailing: 'Geländer',
  cardTitleStairs: 'Treppe',
  cardTitleBalcony: 'Balkon',
  cardTitlePergola: 'Überdachung/Pergola​',
  cardTitleElectrician: 'Elektriker',
  cardTitleGardener: 'Gärtner',
  cardTitleArchitect: 'Architekt/Bauleiter',
  cardTitleCustom: 'Benutzerdefiniert',
}
